
import { setComponentTemplate } from "@ember/component";
import template from "../../draggable-object.hbs";
import component from "../../../../components/draggable-object.js";
export default setComponentTemplate(template, component);
